// Camera permission helpers
// Returns 'granted' | 'prompt' | 'denied'.
// Browsers that cannot query the 'camera' permission (e.g., Firefox)
// will report 'prompt' so the page can be shown.
export const queryCameraPermission = async () => {
  try {
    const status = await navigator.permissions.query({ name: "camera" });
    return status.state;
  } catch {
    return "prompt";
  }
};

// Chrome on Android automatically leaves fullscreen while its permission dialog
// is up, and this may break the portrait-lock. Therefore we leave fullscreen
// properly first — this keeps the page and browser in agreement, and makes the
// later portrait-lock prompt works.
const EXIT_FULLSCREEN_WAIT_MS = 1000;
const exitFullscreenFirst = async () => {
  if (!document.fullscreenElement) return;
  try {
    await Promise.race([
      document.exitFullscreen(),
      new Promise((resolve) => setTimeout(resolve, EXIT_FULLSCREEN_WAIT_MS)),
    ]);
  } catch {
    // already out, or refused — go on with the request regardless.
  }
};

export const requestCameraPermission = async () => {
  await exitFullscreenFirst();
  try {
    const stream = await navigator.mediaDevices.getUserMedia({
      video: true,
      audio: false,
    });

    // Stream stopped right away --
    // the scanner opens its own after the tutorial.
    stream.getTracks().forEach((track) => track.stop());
    return "granted";
  } catch (error) {
    return error?.name === "NotAllowedError" ? "denied" : "prompt";
  }
};
